<template>
   
   <div class="ms-nested-card">
      <div class="ms-nested-header">
         <div class="ms-nested-header__left">
            <span class="ms-nested-title">
               <i class="fas fa-folder-open"></i> Categories
            </span>
         </div>
         <div class="ms-nested-header__right">
            <div class="ms-nested-pagination">
               <button @click="previousPage()" :disabled="pagination.page === 1" class="ms-n-page-btn">
                  <i class="fa fa-chevron-left"></i>
               </button>
               <span class="ms-n-page-label">
                  <strong>{{ paginationLabel }}</strong> of {{ pagination.totalItems }}
               </span>
               <button @click="nextPage()"
                  :disabled="pagination.page === pagination.totalPages || pagination.totalItems === 0"
                  class="ms-n-page-btn">
                  <i class="fa fa-chevron-right"></i>
               </button>
            </div>
             <button v-if="$store.getters['auth/isGlobalSuperAdmin']" type="button" class="ms-btn ms-btn--warning"
                data-bs-toggle="modal" data-bs-target="#categoryForm" @click="onButtonClick('create',items.id)">
                <i class="fas fa-plus"></i> Create Category
             </button>
         </div>
      </div>

      <table class="ms-nested-table" :id="'accordion-category'+catIndex">
          <thead>
             <tr>
                <th v-for="header in headers" :key="header.value">{{ header.text }}</th>
                <th v-if="$store.getters['auth/isGlobalSuperAdmin']" class="ms-th-action">Action</th>
             </tr>
          </thead>

         <tbody v-if="pagination.totalItems <= 0">
             <tr>
                <td :colspan="$store.getters['auth/isGlobalSuperAdmin'] ? 3 : 2" class="ms-nested-empty">No categories found.</td>
             </tr>
         </tbody>

         <tbody v-for="(category, index) in categories" :key="category.id">
            <tr class="ms-nested-row">
               <td class="ms-nested-cell-name">
                  <button class="ms-expand-btn" data-bs-toggle="collapse" :data-bs-target="'#collapseCat'+index"
                     @click="collapseSubTable">
                     <i class="fas fa-chevron-right"></i>
                  </button>
                  <span>{{ category.display_name }}</span>
               </td>
               <td>
                  <span class="ms-count-badge ms-count-badge--subcategory">{{ category.total_subcategory }}</span>
               </td>
                <td v-if="$store.getters['auth/isGlobalSuperAdmin']" class="ms-actions" colspan="2">
                   <button type="button" class="ms-action-btn ms-action-btn--edit" data-bs-toggle="modal" data-bs-target="#categoryForm"
                      @click="onButtonClick('edit',category.id)" title="Edit Category">
                      <i class="fa fa-pen"></i>
                   </button>

                   <span v-if="category.is_used" title="Cannot delete category currently being used.">
                      <button type="button" class="ms-action-btn ms-action-btn--delete ms-action-btn--disabled"
                         @click="onButtonClick('delete',category.id)" :disabled="category.is_used">
                         <i class="fa fa-xmark"></i>
                      </button>
                   </span>
                   <span v-else>
                      <button type="button" class="ms-action-btn ms-action-btn--delete"
                         @click="onButtonClick('delete',category.id)" :disabled="category.is_used">
                         <i class="fa fa-xmark"></i>
                      </button>
                   </span>
                </td>
            </tr>
            
            <!-- SUBCATEGORIES -->
             <tr v-if="category.length != 0" class="ms-sub-collapse collapse" :class="{'hide' : isCollapsed}" 
                :id="'collapseCat'+index" :data-bs-parent="'#accordion-category'+catIndex">
                <td :colspan="$store.getters['auth/isGlobalSuperAdmin'] ? 3 : 2" class="ms-sub-cell">
                   <Subcategory :collapsed="isSubTableCollapsed" :items="category" @onButtonClick="onSubcategoryButtonClick"/>
                </td>
             </tr>
         </tbody>
      </table>
   </div>
   
</template>

<script>
import  Subcategory  from '@/components/MaintenanceSettings/Subcategory.vue';

export default ({

   components: {
      Subcategory
   },

   props: {
      index: {
         type: Number,
         required: true
      },
      items: {
         type: Object,
         required: true,
      },
      mainRowCollapsed: {
         type: Boolean,
      },
      
   },

   data(){
      return{
         headers: [
            { text: "Category Name", value: "categoryName" },
            { text: "No. of Subcategories", value: "numberOfSubcategories" },
         ],
         groups: [],
         categories: [],
         pagination: {
            pageSize: 10,
            page: 1,
            totalItems: 0,
            totalPages: 1,
         },
         isSubTableCollapsed: true,
      }
   },

   created() {
      this.init()
   },

   computed: {

      itemList(){
         return this.items
      },

      paginationLabel() {
         var start =  Math.min((this.pagination.page - 1) * this.pagination.pageSize + 1, this.pagination.totalItems);
         var end = Math.min((this.pagination.page * this.pagination.pageSize), this.pagination.totalItems)

         return start + " - " + end
      },

      currentPage() {
         return this.pagination.page
      },

      catIndex(){
         return this.index
      },

      isCollapsed(){
         return this.mainRowCollapsed
      },

   },

   watch: {

      itemList(){
         this.init()
      },

      currentPage() {
         this.getCategoriesList(this.items.id)
      },

      isCollapsed(){
         this.pagination.page = 1
         this.init()
      },

   },

   methods: {

      init(){
         if(this.pagination.page > 1) {
            this.getCategoriesList(this.items.id)
         } else {
            this.categories = this.items.categories
            this.pagination.totalItems = this.items.total_category
            this.pagination.totalPages = Math.ceil(this.pagination.totalItems / this.pagination.pageSize)
         }
      },

      collapseSubTable(){
         this.isSubTableCollapsed = !this.isSubTableCollapsed
      },

      onButtonClick(action, id){
         this.$emit('onButtonClick', action, id)
      },

      onSubcategoryButtonClick(action, id){
         this.$emit('onSubcategoryButtonClick', action, id, this.items.id)
      },

      previousPage(){
         this.pagination.page > 1 ? this.pagination.page -= 1 : ''
      },

      nextPage() {
         this.pagination.totalPages > this.pagination.page ? this.pagination.page += 1 : ''
      },

      async getCategoriesList(groupId){

         await this.$axios.get("/categories?groupId="+groupId+"&pageSize="+this.pagination.pageSize+"&page="+this.pagination.page)
         .then((response) => {
            this.categories = response.data.categories
            this.pagination.totalItems = response.data.total_items
            this.pagination.totalPages = Math.ceil(this.pagination.totalItems / this.pagination.pageSize)
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })
      },
      
   }
  
})
</script>

<style scoped>
.ms-nested-card {
   background: #fff;
   border: 1.5px solid #e2e8f0;
   border-radius: 12px;
   margin: 12px 0;
   overflow: hidden;
}

.ms-nested-header {
   display: flex;
   align-items: center;
   justify-content: space-between;
   flex-wrap: wrap;
   gap: 10px;
   padding: 12px 16px;
   background: linear-gradient(135deg, #fefce8 0%, #fef3c7 100%);
   border-bottom: 1px solid #fde68a;
}

.ms-nested-title {
   font-weight: 700;
   font-size: 0.82rem;
   color: #92400e;
   text-transform: uppercase;
   letter-spacing: 0.5px;
}

.ms-nested-title i {
   margin-right: 6px;
}

.ms-nested-header__right {
   display: flex;
   align-items: center;
   gap: 12px;
}

.ms-nested-pagination {
   display: inline-flex;
   align-items: center;
   border: 1.5px solid #fde68a;
   border-radius: 8px;
   background: rgba(255, 255, 255, 0.7);
}

.ms-n-page-btn {
   background: transparent;
   border: none;
   cursor: pointer;
   color: #b45309;
   font-size: 0.75rem;
   padding: 5px 10px;
   transition: background-color 0.15s;
}

.ms-n-page-btn:hover:not(:disabled) {
   background: rgba(251, 191, 36, 0.15);
}

.ms-n-page-btn:disabled {
   color: #d4a574;
   cursor: not-allowed;
}

.ms-n-page-label {
   font-size: 0.78rem;
   color: #92400e;
   font-weight: 500;
   padding: 0 4px;
   white-space: nowrap;
}

.ms-n-page-label strong {
   color: #78350f;
}

.ms-btn {
   padding: 7px 16px;
   border-radius: 8px;
   font-size: 0.8rem;
   font-weight: 600;
   cursor: pointer;
   display: inline-flex;
   align-items: center;
   gap: 5px;
   transition: all 0.2s ease;
   border: none;
}

.ms-btn--warning {
   background: linear-gradient(135deg, #f59e0b, #fbbf24);
   color: #fff;
   box-shadow: 0 2px 6px rgba(245, 158, 11, 0.3);
}

.ms-btn--warning:hover {
   background: linear-gradient(135deg, #d97706, #f59e0b);
   box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4);
   transform: translateY(-1px);
}

.ms-nested-table {
   width: 100%;
   border-collapse: collapse;
}

.ms-nested-table thead tr {
   background: #f8fafc;
}

.ms-nested-table th {
   padding: 10px 16px;
   text-align: left;
   font-size: 0.72rem;
   font-weight: 700;
   color: #64748b;
   text-transform: uppercase;
   letter-spacing: 0.5px;
   border-bottom: 1px solid #e2e8f0;
}

.ms-th-action {
   text-align: right;
}

.ms-nested-table td {
   padding: 11px 16px;
   font-size: 0.85rem;
   color: #334155;
   border-bottom: 1px solid #f1f5f9;
   vertical-align: middle;
}

.ms-nested-row:hover {
   background: #fafbff;
}

.ms-nested-cell-name {
   display: flex;
   align-items: center;
   gap: 8px;
   font-weight: 500;
}

.ms-nested-empty {
   text-align: center;
   padding: 24px 16px !important;
   color: #94a3b8;
   font-style: italic;
}

.ms-expand-btn {
   background: none;
   border: none;
   cursor: pointer;
   color: #00A0C1;
   font-size: 0.65rem;
   width: 24px;
   height: 24px;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   border-radius: 6px;
   transition: background-color 0.15s;
   flex-shrink: 0;
}

.ms-expand-btn:hover {
   background: #e6f7fa;
}

.ms-count-badge {
   display: inline-flex;
   align-items: center;
   justify-content: center;
   min-width: 24px;
   padding: 2px 8px;
   border-radius: 12px;
   font-size: 0.75rem;
   font-weight: 700;
}

.ms-count-badge--subcategory {
   background: #ecfdf5;
   color: #059669;
}

.ms-actions {
   text-align: right;
   white-space: nowrap;
}

.ms-action-btn {
   width: 32px;
   height: 32px;
   border-radius: 8px;
   border: none;
   cursor: pointer;
   font-size: 0.78rem;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   margin-left: 4px;
   transition: transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}

.ms-action-btn:hover {
   transform: translateY(-1px);
   box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
}

.ms-action-btn--edit {
   background: #e6f7fa;
   color: #00A0C1;
}

.ms-action-btn--edit:hover {
   background: #00A0C1;
   color: #fff;
}

.ms-action-btn--delete {
   background: #fef2f2;
   color: #dc2626;
}

.ms-action-btn--delete:hover {
   background: #dc2626;
   color: #fff;
}

.ms-action-btn--disabled {
   opacity: 0.4;
   cursor: not-allowed;
}

.ms-action-btn--disabled:hover {
   transform: none;
   box-shadow: none;
   background: #fef2f2;
   color: #dc2626;
}

.ms-sub-collapse {
   background: #f8fafc;
}

.ms-sub-cell {
   padding: 0 8px 8px !important;
   border-bottom: none !important;
}
</style>
